// extracted by mini-css-extract-plugin
export default {"terms-notice":"styles_terms-notice__AaxKh"};